module.exports = __webpack_public_path__ + "img/slide3.a640f354.png";